<template>
	<div style="padding: 20px 20px 20px 0;">
		<el-dialog title="修改" :visible.sync="isChange" width="30%" :close-on-click-modal="false"
		  :modal-append-to-body="false" :before-close="handleClose">
			<el-form :model="isXx" :rules="rules" ref="isXx">
				<el-form-item prop="company" label="业主单位">
					
					<el-input :disabled="true" v-model="isXx.company"></el-input>
				</el-form-item>
				<el-form-item prop="roomNum" label="房间号">
					<el-input :disabled="true" v-model="isXx.roomNum"></el-input>
				</el-form-item>
				<el-form-item prop="year" label="年份">
					<el-input :disabled="true" v-model="isXx.year"></el-input>
				</el-form-item>
				<el-form-item prop="month" label="月份">
					<el-input :disabled="true" v-model="isXx.month"></el-input>
				</el-form-item>
				<el-form-item label="缴费模式" prop="property">
					<el-select v-model="isXx.property">
						<el-option label="个人缴纳" value="个人缴纳"></el-option>
						<el-option label="单位缴纳" value="单位缴纳"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="status" label="结清状态">
					<el-select v-model="isXx.status" placeholder="请选择结清状态">
						<el-option label="已支付" :value="1"></el-option>
						<el-option label="未支付" :value="0"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="上传凭证">
					<el-upload class="avatar-uploader" action="/api/admin/roomManage/uploadRoomPictureFile" :show-file-list="false"
					 :on-success="handleAvatarSuccess" :headers="headerData" name="file" :before-upload="beforeAvatarUpload">
						<img v-if="isXx.showPath" :src="isXx.showPath" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						<div class="el-upload__tip" slot="tip">只能上传jpg/png/jpeg文件，且不超过1MB</div>
					</el-upload>
					</el-upload>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="confirmClick">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="新增" :visible.sync="addShow" width="30%" :close-on-click-modal="false"
		  :modal-append-to-body="false" :before-close="handleClose2">
			<el-form :model="addList" >
				<el-form-item prop="roomNum" label="房间号">
					<el-select @change="goChange(addList.roomNum)" v-model="addList.roomNum">
						<el-option  v-for="s in roomList" :label="s.roomNum" :value="s.roomNum"></el-option>
					</el-select>
					
				</el-form-item>
				<el-form-item prop="company" label="业主单位">
				
					<el-input :disabled="true" v-model="addList.company"></el-input>
				</el-form-item>
				<el-form-item prop="area" label="面积">
					<el-input :disabled="true" v-model="addList.area"></el-input>
				</el-form-item>
				<el-form-item prop="userName" label="住户">
					<el-input :disabled="true" v-model="addList.userName"></el-input>
				</el-form-item>
				<el-form-item prop="userPhone" label="联系方式">
					<el-input :disabled="true" v-model="addList.userPhone"></el-input>
				</el-form-item>
				<el-form-item prop="time" label="电费年月">
					<el-date-picker v-model="addList.time" value-format="yyyy-MM" type="month"
						placeholder="选择日期">
					</el-date-picker>
					<!-- <el-date-picker v-model="addList.time" type="date" placeholder="选择日期" >
					</el-date-picker> -->
				</el-form-item>
				<!-- <el-form-item prop="year" label="年份">
					<el-input  v-model="addList.year"></el-input>
				</el-form-item>
				<el-form-item prop="month" label="月份">
					<el-input  v-model="addList.month"></el-input>
				</el-form-item> -->
				<el-form-item label="缴费模式" prop="property">
					<el-select v-model="addList.property">
						<el-option label="单位缴纳" value="单位缴纳"></el-option>
						<el-option label="个人缴纳" value="个人缴纳"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="status" label="结清状态">
					<el-select v-model="addList.status" placeholder="请选择结清状态">
						<el-option label="已支付" :value="1"></el-option>
						<el-option label="未支付" :value="0"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="上传凭证">
					<el-upload class="avatar-uploader" action="/api/admin/roomManage/uploadRoomPictureFile" :show-file-list="false"
					 :on-success="handleAvatarSuccess2" :headers="headerData" name="file" :before-upload="beforeAvatarUpload">
						<img v-if="addList.showPath" :src="addList.showPath" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						<div class="el-upload__tip" slot="tip">只能上传jpg/png/jpeg文件，且不超过1MB</div>
					</el-upload>
					</el-upload>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose2">取 消</el-button>
				<el-button type="primary" @click="goYes">确 定</el-button>
			</span>
		</el-dialog>
		<!-- tab页 -->
		<el-tabs v-model="selectForm.flag" @tab-click="getAll()">
			<el-tab-pane label="公寓" name="1"></el-tab-pane>
			<el-tab-pane label="商场" name="2"></el-tab-pane>
		</el-tabs>
		<!-- 搜索条件 -->
		<div>
			<el-form :inline="true" :model="selectForm" ref="selectForm">
				<el-form-item label="业主单位" prop="shopId">
					<el-autocomplete v-model="selectForm.shopId" :fetch-suggestions="querySearchAsync" placeholder="请输入单位名称"
					 value-key="deptId" clearable @clear="clearShopSearch" ref="shopAutocomplete"></el-autocomplete>
				<!-- 	<el-select style="width: 200px;" v-model="selectForm.company">
						<el-option v-for="(item,index) in yzlist" :label="item.unitName" :value="item.unitName"></el-option>
					</el-select> -->
				</el-form-item>
				<el-form-item label="房间号" prop="roomId">
					<el-autocomplete :disabled="title=='修改'" v-model="selectForm.roomId" :fetch-suggestions="querySearchAsync2"
						placeholder="请输入所属单位" value-key="id" clearable @clear="cleaRoomSearch"
						ref="rootAutocomplete"></el-autocomplete>
					<!-- <el-input v-model="selectForm.roomNum" placeholder="房间号"></el-input> -->
				</el-form-item>
				<!--el-form-item label="联系方式" prop="userPhone">
					<el-input v-model="selectForm.userPhone" placeholder="联系方式"></el-input>
				</el-form-item--> 
				<el-form-item label="缴费区间">
					<el-date-picker v-model="selectForm.createTimeStart" type="datetime" placeholder="开始时间">
					</el-date-picker>
					<span>-</span>
					<el-date-picker v-model="selectForm.createTimeEnd" type="datetime" placeholder="结束时间">
					</el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="getAll">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="$refs.selectForm.resetFields();getAll();">重置</el-button>
				</el-form-item>
				<el-form-item>
					<!-- <el-button v-if="selectForm.flag==1" type="primary" @click="getAdd">新增</el-button> -->
				</el-form-item>
				<!-- <el-form-item>
					<div style="font-size: 25px;">共计{{count}}条记录</div>
				</el-form-item>
				<el-form-item>
					<div style="font-size: 25px;">共计{{sum}}元</div>
				</el-form-item> -->
			</el-form>
		</div>
		<el-table :data="data" style="width: 100%" border>
			<el-table-column prop="company" label="业主单位" align="center"></el-table-column>
			<el-table-column prop="company" label="栋" align="center"></el-table-column>
			<el-table-column prop="roomNum" label="房间号" align="center"></el-table-column>
			<!-- <el-table-column  label="最近缴费日期" align="center">
				<template slot-scope="{row}">
					{{setTime(row.time)}}
				</template>
			</el-table-column> -->
			<el-table-column prop="area" label="单价" align="center"></el-table-column>
			<el-table-column prop="area" label="面积" align="center"></el-table-column>
			<el-table-column prop="userName" label="住户" align="center"></el-table-column>
			<el-table-column prop="userPhone" label="联系方式" align="center"></el-table-column>
			<el-table-column prop="userPhone" label="金额(元/月)" align="center"></el-table-column>
			<el-table-column prop="userPhone" label="金额(元/年)" align="center"></el-table-column>
			<el-table-column prop="userPhone" label="物业费期间" align="center"></el-table-column>
			<el-table-column prop="userPhone" label="应收物业费余额" align="center"></el-table-column>
			
			<el-table-column label="操作" align="center">
				<template slot-scope="scope">
					 <!-- v-if="scope.row.property=='代缴'" -->
					<el-button  type="text" @click="setRow(scope.row)">修改</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination @size-change="sizeChange" @current-change="currentChange" :page-sizes="[10, 20, 30, 40]"
			:page-size="selectForm.size" layout="total, sizes, prev, pager, next, jumper" :total="totalNum"
			style="margin-top: 10px;">
		</el-pagination>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				addList:{
					
				},
				count:0, sum:0,
				headerData: {
					Authorization: localStorage.access_token
				},
				activeName: "1",
				form: { //表单数据
					name: "",
					age: ""
				},
				oldForm: undefined, //表单备份数据
				data: [], //表格数据
				selectForm: { //查询条件
					currentPage: 1, //当前页
					pageSize: 10, //页大小
					flag: '1',
					company: '',
					roomNum: '',
					userPhone: null,
					
				},
				totalNum: 0, //数据总数
				show: false, //控制弹窗
				title: "",
				disable: false, //节流
				yzlist:[],
				isChange:false,
				formData:{
					filePath:null,
					showPath:null,
					status:null
				},
				rules: {
					status: [{
						required: true,
						message: "结清状态不能为空",
						trigger: ["blur", "change"]
					}],
					unitName: [{
						required: true,
						message: "单位名称不能为空",
						trigger: ["blur", "change"]
					}],
					property: [{
						required: true,
						message: "缴费模式不能为空",
						trigger: ["blur", "change"]
					}],
				},
				isXx:{},
				addShow:false,
				roomList:[]
			}
		},
		methods: {
			// 查询所有单位信息
			clearRoomSearch() {
				this.$refs.rootAutocomplete.handleFocus()
			},
			querySearchAsync2(queryString, cb) {
				console.log(queryString)
				
				this.$http.get('/api/bdWaterElectricityPayment/selectRoomNumApartment?roomNum=' + queryString).then(res => {
					console.log("查询所有单位信息", res.data.data);
					let result = res.data.data;
					cb(result);
				})
			},
			querySearchAsync(queryString, cb) {
				this.$http.get('/api/ownerManage/getOwners?company=' + this.selectForm.company).then(res => {
					console.log("查询所有单位信息", res);
					let result = res.data.data;
					cb(result);
				})
			},
			// 解决el-autocomplete使用clearable，失效问题
			clearShopSearch() {
				this.$refs.shopAutocomplete.handleFocus()
			},
			// goCheck(){
			goChange(e){
				console.log(e)
				this.$http.get(`/api/wuye/pay/selectOneRoomMessage?roomNum=${e}`).then(res=>{
					console.log(res)
					this.addList=res.data.data
					
				})
			},
			goYes(){
				this.addList.year = parseInt(this.addList.time.split("-")[0])
				this.addList.month = parseInt(this.addList.time.split("-")[1])
				this.addList.time = null
				// this.addList.year= new Date(this.addList.time).getFullYear()
				// this.addList.month=new Date(this.addList.time).getMonth()+1
				this.$http.post("/api/wuye/pay/insert",{
					...this.addList,
					flag:'1'
				}).then(res=>{
					
					console.log(res)
					if(res.data.code==-1){
						this.$message.error(res.data.message)
					}else{
						this.addShow=false
						this.$message.success(res.data.message)
						this.getAll()
					}
					
				})
			},
			getAdd(){
				this.addShow=true
				this.$http.get("/api/wuye/pay/selectAllRoomMessage").then(res=>{
					console.log(res)
					this.roomList=res.data.data
				})
			},
			confirmClick(){
				this.$refs.isXx.validate((valid) => {
					if (valid) {
						this.$http.post("/api/wuye/pay/update",{
							...this.isXx
						}).then(res=>{
							if(res.data.code==0){
								this.isChange=false
								this.getAll()
							}
							console.log(res)
						})
					} else {
						return;
					}
							
				})
			},
			beforeAvatarUpload(file) {
				console.log(file);
				var isJPG = null;
				if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg') {
					isJPG = true;
				} else {
					isJPG = false;
				}
				const isLt2M = file.size / 1024 / 1024 < 1;
				if (!isJPG) {
					this.$message.error('上传Logo只能是 JPG/JPEG/PNG 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 1MB!');
				}
				return isLt2M && isJPG;
			},
			handleAvatarSuccess2(file){
				console.log(file)
				this.addList.filePath = file.data.filePath;
				this.addList.showPath = file.data.showPath;
			},
			// 上传成功
			handleAvatarSuccess(file) {
				console.log(file);
				this.isXx.filePath = file.data.filePath;
				this.isXx.showPath = file.data.showPath;
				console.log(this.formData);
			},
			handleClose2(){
				this.addShow=false
			},
			handleClose(){
				this.isChange=false
			},
			getYzList(){
				this.$http.get("/api/ownerManage/getOwners").then(res=>{
					console.log(res)
					this.yzlist=res.data.data
				})
			},
			ok() {
				this.disable = true;
				let url = "/api/set"
				if (this.title[0] == "新") {
					url = "/api/add"
				}
				this.$http.post(url, this.form).then(res => {
					this.disable = false
					if (res.data.code == 0) {
						this.show = false;
						this.$message.success(`${this.title}成功`)
						this.getAll();
					} else {
						this.$message.error(`${this.title}失败`)
					}
				})
			},
			delRow(row) { //删除被点击
				this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post(``, {
						id: row.id
					}).then(res => {
						if (res.data.code == 0) {
							this.$message.success("删除成功")
							this.getAll();
						} else {
							this.$message.error("删除失败")
						}
					})
				}).catch(() => {
					this.$message.info('已取消删除');
				});
			},
			setRow(row) { //修改被点击
				this.isChange=true
				this.isXx=row
			},
			close() { //弹框关闭
				this.$refs.form.resetFields()
				this.form = JSON.parse(JSON.stringify(this.oldForm));
			},
			getAll() { //获取表格数据

				this.$http.get(`/api/wuye/pay/select`, {
					params:{
						...this.selectForm
					}
					
				}).then(
					res => { 

						if(res.data.data!=null){
							this.data = res.data.data.items;
							this.totalNum=res.data.data.totalNum
							this.count=this.totalNum
							this.sum=res.data.data.sum
						}else{
							this.data=null
							this.totalNum=0
							this.count=0
							this.sum=0
						}
					})
			},
			sizeChange(size) { //页大小被修改
				this.selectForm.pageSize = size;
				this.getAll();
			},
			currentChange(page) { //当前页被修改
				this.selectForm.currentPage = page;
				this.getAll();
			}
		},
		mounted() {
			this.oldForm = JSON.parse(JSON.stringify(this.form))
			this.getYzList()
			this.getAll();
		}
	}
</script>

<style>
</style>
